import { createTheme, ThemeOptions } from "@mui/material/styles";
import { TypographyOptions } from "@mui/material/styles/createTypography";
import React from "react";
import { color } from "./color";
import { font } from "./font";

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    gridRegularText: true;
    gridLinkBoldText: true;
  }
}

interface ExtendedTypographyOptions extends TypographyOptions {
  gridRegularText: React.CSSProperties;
  gridLinkBoldText: React.CSSProperties;
}
const theme = createTheme({
  // spacing: (factor) => `${0.25 * factor}rem`,
  spacing: (factor: number) => `${0.25 * factor * 16}px`,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 930,
      lg: 1100,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: color.primary.main,
      dark: color.primary.dark,
      contrastText: color.primary.contrastText,
    },
    secondary: {
      light: color.secondary.light,
      main: color.secondary.main,
      dark: color.tertiary.dark,
      contrastText: color.primary.contrastText,
    },
    text: {
      primary: color.text.primary,
      secondary: color.text.secondary,
    },
    background: {
      default: color.grayTone.white,
    },
  },
  typography: {
    fontFamily: font.primary,
    gridLinkBoldText: {
      fontFamily: font.primary,
      fontSize: "1rem",
      fontWeight: 600,
      color: color.tertiary.dark,
    },
    gridRegularText: {
      fontFamily: font.primary,
      fontSize: "1rem",
      color: color.grayTone.black,
    },
    h1: {
      fontFamily: font.primary,
      // fontSize: "2.75rem",
      fontSize: "clamp(1.5rem, 3vw + 1rem, 2.75rem)",
      fontWeight: 400,
      lineHeight: 1.2,
      letterSpacing: "1px",
    },
    h2: {
      fontFamily: font.secondary,
      // fontSize: "1.5rem",
      fontSize: "clamp(1.2rem, 2vw + 1rem, 1.5rem)",
      fontWeight: 400,
      whiteSpace: "pre-wrap",
      lineHeight: 1.5,
    },
    h3: {
      fontFamily: font.secondary,
      // fontSize: "1.25rem",
      fontSize: "clamp(1.2rem, 2vw + 1rem, 1.5rem)",
      color: color.text.primary,
      fontWeight: 400,
      lineHeight: 1.5,
    },
    h4: {
      fontFamily: font.secondary,
      fontSize: "1.0rem",
      fontWeight: 400,
      color: color.text.secondary,
      lineHeight: 2,
    },
    h5: {
      fontFamily: font.secondary,
      fontSize: "1.0rem",
      fontWeight: 400,
      color: color.text.secondary,
      lineHeight: 2,
    },
    h6: {},
    subtitle1: {},
    subtitle2: {},
    body1: {
      fontFamily: font.secondary,
      color: color.text.secondary,
      fontSize: "1rem",
      lineHeight: 1.5,
      whiteSpace: "pre-wrap",
    },
    body2: {
      fontFamily: font.secondary,
      color: color.grayTone.bodyCopy,
      fontWeight: 400,
      fontSize: "1rem",
      whiteSpace: "pre-wrap",
    },
    button: {
      fontFamily: font.primary,
      fontSize: "1.2rem",
      lineHeight: "28px",
      textTransform: "none",
      letterSpacing: "0.45712px",
    },
    caption: {
      fontFamily: font.primary,
      fontWeight: 400,
      fontSize: "1rem",
    },
    overline: {
      fontFamily: font.primary,
      fontSize: "1rem",
      fontWeight: 400,
    },
  } as ExtendedTypographyOptions,
} as ThemeOptions);

export { theme, color, font };
